$giper_baza_app_stat_page $mol_page
	home $giper_baza_app_home
		link => home_link
	title \📊 Server Statistics
	head /
		<= Main $mol_view sub / 
			<= Land $giper_baza_link_chip
				link <= home_link
				arg *
					section \glob
					^
			<= Uptime $mol_chip title <= uptime \🔴 00:00
		<= Tools
	body_content /
		<= Charts $mol_gallery items /
			<= Cpu $mol_chart
				graphs /
					<= Cpu_user $mol_plot_line
						title \CPU User (%)
						series_y <= cpu_user /
					<= Cpu_system $mol_plot_line
						title \CPU System (%)
						series_y <= cpu_system /
					<= Cpu_ruler_sec $mol_plot_ruler_vert
					<= Cpu_mark $mol_plot_mark_cross
						labels <= times /
						graphs /
							<= Cpu_user
							<= Cpu_system
			<= Mem $mol_chart
				graphs /
					<= Mem_free $mol_plot_line
						title \Mem Free (%)
						series_y <= mem_free /
					<= Mem_used $mol_plot_line
						title \Mem Used (%)
						series_y <= mem_used /
					<= Mem_ruler $mol_plot_ruler_vert
					<= Mem_mark $mol_plot_mark_cross
						labels <= times /
						graphs /
							<= Mem_used
							<= Mem_free
			<= Fs_usage $mol_chart
				graphs /
					<= Fs_free $mol_plot_line
						title \FS Free (%)
						series_y <= fs_free /
					<= Fs_usage_ruler $mol_plot_ruler_vert
					<= Fs_usage_mark $mol_plot_mark_cross
						labels <= times /
						graphs /
							<= Fs_free
			<= Fs_acting $mol_chart
				graphs /
					<= Fs_reads $mol_plot_line
						title \FS Reads / sec
						series_y <= fs_reads /
					<= Fs_writes $mol_plot_line
						title \FS Writes / sec
						series_y <= fs_writes /
					<= Fs_acting_ruler $mol_plot_ruler_vert
					<= Fs_acting_mark $mol_plot_mark_cross
						labels <= times /
						graphs /
							<= Fs_reads
							<= Fs_writes
			<= Ports $mol_chart
				graphs /
					<= Port_slaves $mol_plot_line
						title \Slave Ports
						series_y <= port_slaves /
					<= Port_masters $mol_plot_line
						title \Master Ports
						series_y <= port_masters /
					<= Port_ruler_pct $mol_plot_ruler_vert
					<= Port_mark $mol_plot_mark_cross
						labels <= times /
						graphs /
							<= Port_slaves
							<= Port_masters
			<= Land_count $mol_chart
				graphs /
					<= Land_active $mol_plot_line
						title \Active Lands
						series_y <= land_active /
					<= Land_count_ruler $mol_plot_ruler_vert
					<= Land_count_mark $mol_plot_mark_cross
						labels <= times /
						graphs /
							<= Land_active
			<= Error_count $mol_chart
				graphs /
					<= Errors $mol_plot_line
						title \Errors
						series_y <= errors /
					<= Error_count_ruler $mol_plot_ruler_vert
					<= Error_count_mark $mol_plot_mark_cross
						labels <= times /
						graphs /
							<= Errors
